"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSelectionRowEvent = exports.isSelectionColumnEvent = exports.createSelectionColumn = exports.SPACE_BAR = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var LayoutStyles_1 = require("../style/LayoutStyles");
var StyleFunctions_1 = require("../style/StyleFunctions");
var TypedDataGridInterfaces_1 = require("./TypedDataGridInterfaces");
var CellStyles_1 = require("./cellFormatters/CellStyles");
exports.SPACE_BAR = ' ';
var selectionContainerClass = StyleFunctions_1.cssClass('selectionContainer', LayoutStyles_1.elideTextStyle, CellStyles_1.cellPaddingStyle, {
    height: '100%'
});
function createSelectionColumn() {
    return {
        name: TypedDataGridInterfaces_1.SelectionColumnKey,
        dataKey: TypedDataGridInterfaces_1.SelectionColumnKey,
        headerText: '',
        // eslint-disable-next-line react/display-name
        cellFormatter: function (props) { return (React.createElement("div", { className: selectionContainerClass },
            React.createElement(widgets_1.CheckBoxWidget, { checked: props.isSelected, testId: "checkbox-cell-" + props.row.key }))); },
        resizable: false,
        sortable: false,
    };
}
exports.createSelectionColumn = createSelectionColumn;
function isSelectionColumnEvent(event) {
    var isSelectionColumn = event.cell.colKey === TypedDataGridInterfaces_1.SelectionColumnKey;
    var fromMouseClick = event.type === 'mousedown';
    var fromSpaceBarPress = event.type === 'keydown' && event.key === exports.SPACE_BAR;
    return isSelectionColumn && (fromMouseClick || fromSpaceBarPress);
}
exports.isSelectionColumnEvent = isSelectionColumnEvent;
function isSelectionRowEvent(event) {
    var isSelection = !!event.cell.rowKey;
    // TFSID 928989
    // Disabling space bar press selection given keyboard navigation is not working
    return isSelection && (event.type === 'mousedown' || event.type === 'touchstart');
}
exports.isSelectionRowEvent = isSelectionRowEvent;
//# sourceMappingURL=SelectionColumn.js.map